const utilities = {
  generateUUID: () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      (currentChar) => {
        const randomNum = Math.floor(Math.random() * 16);
        const valueReplaced =
          currentChar === "x" ? randomNum : (randomNum & 0x3) | 0x8;
        return valueReplaced.toString(16);
      },
    );
  },
};

export default utilities;
